var exports = {
  "k": "x234b8571--b57883--container",
  "i": "x234b8571--b57883--wrapper",
};

module.exports = exports;
